const HeadingOutline2 = () => {
  return (
    <svg viewBox="0 0 170 90" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse
        cx="85"
        cy="45"
        rx="83"
        ry="43"
        stroke="#CB1D8D"
        strokeWidth="3"
      />
    </svg>
  );
};

export default HeadingOutline2;
